// Поля orderData/wallet, которые бэкенд отдаёт строками, но потребляются как числа.
export const NUMERIC_ORDER_FIELDS = [
  'BONUS_VALUE',
  'CW_VALUE',
  'CW_VALUE_LIMIT',
  'DELIVERY_PRICE',
  'DUTY',
  'FULL_PRICE',
  'PRICE',
  'PRICE_BASE',
  'PRICE_CLUB',
  'TAX',
  'TOTAL_PRICE',
  'TOTAL_PRICE_WITH_PROMO',
  'TRANSFER_POINTS',
  'STANDARD_POINTS',
]
